import { CSSProperties } from 'react'

const styles: {
  base: CSSProperties
  hovered: CSSProperties
} = {
  base: {
    cursor: 'pointer',
  },
  hovered: {
    backgroundColor: 'red',
  },
}

export default styles
